import { useSelector } from 'react-redux';
import useGtmHook from './useGtmHook';
import { APPLICATION_SECURE_COMPLETE } from '../gtmEvents';
import { selectApplication } from '../../store/selectors/applicationSelectors';
import { APPLICATION_TYPE } from '../constants';

const useGtmSecureHook = () => {
  const Application = useSelector(selectApplication);
  const { gtmEvent } = useGtmHook();

  const { ApplicationType } = Application;

  const gtmApplicationSecureHook = () => {
    gtmEvent(APPLICATION_SECURE_COMPLETE, {
      event_label: 'registration',
      application_type: APPLICATION_TYPE[ApplicationType],
    });
  };

  return { gtmApplicationSecureHook };
};

useGtmSecureHook.propTypes = {};

export default useGtmSecureHook;
